import { keyframes } from '@chakra-ui/react'

/** CTA arrow nudge of the Medleve home "Começar" button, reused by the Cuidei landing CTAs. */
export const arrowNudge = keyframes`
  0%, 60%, 100% { transform: translateX(0); }
  20% { transform: translateX(8px); }
  40% { transform: translateX(0); }
`

export const ARROW_NUDGE_ANIMATION = `${arrowNudge} 2.2s ease-in-out infinite`
